import { Link } from 'react-router-dom'
import React from 'react'
import { values as userRole } from '../../model/enum/Role'
import localize from '../../utils/localize'
import RoutePaths from '../../configs/RoutePaths'

const CreateTTS = ({ role }) => {
    return [userRole.ADMIN, userRole.SUPERVISOR, userRole.SALES_AGENT].includes(role) ? (
        <div className="row">
            <Link to={RoutePaths.LOAN_PATH}>
                <button type="button" className="btn btn-default btn-block btn-large">
                    {localize.strings.DynamicTTS}
                </button>
            </Link>
        </div>
    ) : (
        <></>
    )
}
export default CreateTTS
